const l = {
  name: "FormulaTalkStraight",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M39.1,14H40v2.5l-0.3,0.2c0.2,1.1,0.3,2.2,0.3,3.3s-0.1,2.2-0.3,3.3l0.3,0.2V26h-0.9C36.5,34.1,29,40,20,40
			c-4.1,0-7.8-1.2-11-3.3l-8.6,2.9L3.3,31C1.2,27.8,0,24.1,0,20C0,9,9,0,20,0C29,0,36.5,5.9,39.1,14z M20,2C10.1,2,2,10.1,2,20
			c0,3.8,1.2,7.3,3.2,10.2l0.3,0.4l-1.9,5.8l5.8-1.9l0.4,0.3c2.9,2,6.4,3.2,10.2,3.2c7.8,0,14.5-5,17-12h-3.2c-2.3,5.3-7.6,9-13.7,9
			c-8.3,0-15-6.7-15-15S11.7,5,20,5c6.2,0,11.4,3.7,13.7,9H37C34.5,7,27.8,2,20,2z M37.9,18.2L35.6,20l2.3,1.8
			C38,21.2,38,20.6,38,20C38,19.4,38,18.8,37.9,18.2z M31.5,14C29.4,9.8,25,7,20,7C12.8,7,7,12.8,7,20s5.8,13,13,13
			c5,0,9.4-2.8,11.5-7h-0.9L29,24.4c-1.6,3.3-5,5.6-9,5.6c-5.5,0-10-4.5-10-10s4.5-10,10-10c3.9,0,7.4,2.3,9,5.6l1.6-1.6H31.5z
			 M27.5,17.1c-1.1-3-4.1-5.1-7.5-5.1c-4.4,0-8,3.6-8,8s3.6,8,8,8c3.4,0,6.3-2.1,7.5-5.1L25.6,21h-0.7c-0.5,2.3-2.5,4-4.9,4
			c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.4,0,4.4,1.7,4.9,4h0.7L27.5,17.1z M37.4,24l-3.7-3h-5.2l3,3H37.4z M28.4,19h5.2l3.7-3h-6L28.4,19z
			 M20,17c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2H20v-2h2.8C22.4,17.8,21.3,17,20,17z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as FormulaTalkStraight
};
